import React from "react";

export function Wrapper({
  when,
  render,
  children,
}: React.PropsWithChildren<{
  when: boolean;
  render(children: React.ReactNode): React.ReactNode;
}>) {
  return <>{when ? render(children) : children}</>;
}
